import { FilterInfo } from "../common/models/CommonModels";
import { momentToString, momentToDtoString } from "../utils/dateUtilities";

export const createFilterUrl = (filters: FilterInfo | undefined): string => {
    const fil: string[] = [];

    if (filters && filters.fromDate) {
        fil.push(`fromDate=${filters.fromDate.format("YYYY-MM-DD HH:mm")}`)
    }

    if (filters && filters.toDate) {
        fil.push(`toDate=${filters.toDate.format("YYYY-MM-DD HH:mm")}`)
    } 

    // if (filters && filters.fromDate) {
    //     fil.push(`fromDate=${momentToDtoString(filters.fromDate)}`)
    // }

    // if (filters && filters.toDate) {
    //     fil.push(`toDate=${momentToDtoString(filters.toDate)}`)
    // }


    if (filters && filters.reporter && filters.reporter.length > 0) {
        fil.push(`reportedBy=${filters.reporter.join(",")}`)
    }

    if (filters && filters.fromCities && filters.fromCities.length > 0 ) {
        fil.push(`fromCities=${filters.fromCities.join(",")}`)
    }

    if (filters && filters.toCities && filters.toCities.length > 0 ) {
        fil.push(`toCities=${filters.toCities.join(",")}`)
    }

    if (filters && filters.properties && filters.properties.length > 0) {
        fil.push(`properties=${filters.properties.join(",")}`);
    }

    if (filters && filters.reportNumberSearch) {
        fil.push(`search=${filters.reportNumberSearch}`);
    }

    return `?${fil.join("&")}`
}


export const createCompanyFilterUrl = (filters: FilterInfo | undefined): string => {
    const fil: string[] = [];

    if (filters && filters.reportNumberSearch) {
        fil.push(`search=${filters.reportNumberSearch}`);
    }

    return `?${fil.join("&")}`
}


export const createFilterSettingsFilterUrl = (companyId: string | undefined): string => {
    const fil: string[] = [];

    fil.push(`search=${companyId}`);

    return `?${fil.join("&")}`
}



// WEBPACK FOOTER //
// ./src/api/apiFilterUtils.ts